import { z } from 'zod';
import { CallStateSchema, AttemptSchema, OutcomeSchema, ResultsSchema, } from '@nava/outbound-calls-data-contracts';
import { UuidSchema } from './common.js';
/** Immutable session ownership snapshot, keyed by the outbound domain's attempt ID. */
export const AllocateOutboundSessionRequestSchema = z
    .object({
    organizationId: UuidSchema,
    projectId: UuidSchema,
    assignmentId: UuidSchema,
    participantId: z.string().min(1).max(256),
    configVersion: z.number().int().nonnegative(),
    actorUserId: z.string().min(1).max(256),
})
    .strict();
export const OutboundSessionAllocationSchema = z
    .object({
    callAttemptId: UuidSchema,
    sessionId: UuidSchema,
    created: z.boolean(),
})
    .strict();
/** Verified controller snapshot; vendor callback hints alone do not authorize a binding. */
export const BindOutboundConversationRequestSchema = z
    .object({
    organizationId: UuidSchema,
    projectId: UuidSchema,
    assignmentId: UuidSchema,
    participantId: z.string().min(1).max(256),
    sessionId: UuidSchema,
    configVersion: z.number().int().nonnegative(),
    agentReference: z.string().regex(/^agent_[A-Za-z0-9_-]{1,190}$/),
    conversationId: z.string().regex(/^conv_[A-Za-z0-9_-]{1,190}$/),
})
    .strict();
export const OutboundConversationBindingSchema = z
    .object({
    callAttemptId: UuidSchema,
    sessionId: UuidSchema,
    conversationId: z.string().regex(/^conv_[A-Za-z0-9_-]{1,190}$/),
    created: z.boolean(),
})
    .strict();
/** Read-only transport projection; contains no vendor identifiers or participant contact data. */
export const OutboundCallSummarySchema = z
    .object({
    callAttemptId: UuidSchema,
    version: z.number().int().positive(),
    status: CallStateSchema,
    dispatchState: AttemptSchema.shape.dispatchState,
    outcome: OutcomeSchema.nullable(),
    resultsStatus: ResultsSchema,
    observedAt: z.string().datetime({ offset: true }),
    answeredAt: z.string().datetime({ offset: true }).nullable(),
    endedAt: z.string().datetime({ offset: true }).nullable(),
})
    .strict()
    .superRefine((call, context) => {
    if (call.status !== 'ended' && (call.outcome !== null || call.endedAt !== null))
        context.addIssue({ code: 'custom', message: 'Only ended calls carry terminal facts' });
});
export const SyncOutboundSessionRequestSchema = BindOutboundConversationRequestSchema.omit({
    agentReference: true,
    conversationId: true,
}).extend({ call: OutboundCallSummarySchema });
//# sourceMappingURL=OutboundAllocations.js.map